// import { formatGeneral } from 'cleave-zen';
import { ChangeEvent, FC, useState } from 'react';
import { Control, useController } from 'react-hook-form';
import InputMask from 'react-input-mask';
import styled, { css } from 'styled-components';

import ValidationMessage from '@/components/Forms/ValidationMessage';

import { FormDataT } from './ScriptPart';

const InputWrap = styled.div`
  position: relative;
  width: 100%;
`;

const PlusIcon = styled.svg`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  color: ${({ theme }) => theme.colors.gray};
`;

const Input = styled.input<{ $hasError: boolean }>`
  text-align: center;
  width: 100%;
  height: 30px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  font-size: 14px;
  line-height: 22px;
  color: ${({ theme }) => theme.colors.black};
  font-family: 'Manrope';
  font-weight: 700;
  outline: none;
  cursor: pointer;
  border-color: transparent;
  border-width: 1px;
  border-style: solid;
  &::placeholder {
    color: transparent;
  }
  &:focus::placeholder {
    color: ${({ theme }) => theme.colors.lightGray};
  }
  &:placeholder-shown,
  &:focus {
    border-color: ${({ theme }) => theme.colors.lightGray};
  }
  &:hover {
    + ${PlusIcon} {
      color: ${({ theme }) => theme.colors.black};
    }
  }
  ${({ $hasError, theme }) =>
    $hasError &&
    css`
      border-color: ${theme.colors.error} !important;
    `}
`;

interface Props {
  control: Control<FormDataT>;
  name?: 'splittedPart.timestamp' | 'timestamp';
}

const TimestampField: FC<Props> = ({ control, name = 'timestamp' }) => {
  const [isFocused, setIsFocused] = useState(false);

  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController<FormDataT, `timestamp` | `splittedPart.timestamp`>({
    name,
    control,
  });

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(
      // formatGeneral(e.target.value, {
      //   delimiters: [':', '.', ' --> ', ':', '.'],
      //   numericOnly: true,
      //   blocks: [2, 2, 3, 2, 2, 3],
      // }),
      e.target.value,
    );
  };

  return (
    <>
      <InputWrap>
        <InputMask
          mask="99:99.999 --> 99:99.999"
          maskPlaceholder="0"
          onFocus={() => setIsFocused(true)}
          value={value}
          onBlur={() => setIsFocused(false)}
          onChange={handleInputChange}
        >
          <Input $hasError={!!error} placeholder="00:00.000 --> 00:00.000" />
        </InputMask>
        {!value && !isFocused && (
          <PlusIcon
            width="11"
            height="12"
            viewBox="0 0 11 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.25003 1.49902C6.25003 1.08481 5.91425 0.749023 5.50003 0.749023C5.08582 0.749023 4.75003 1.08481 4.75003 1.49902V5.2515H0.999512C0.585298 5.2515 0.249512 5.58728 0.249512 6.0015C0.249512 6.41571 0.585298 6.7515 0.999512 6.7515H4.75003V10.5C4.75003 10.9142 5.08582 11.25 5.50003 11.25C5.91425 11.25 6.25003 10.9142 6.25003 10.5V6.7515H10.0005C10.4147 6.7515 10.7505 6.41571 10.7505 6.0015C10.7505 5.58728 10.4147 5.2515 10.0005 5.2515H6.25003V1.49902Z"
              fill="currentColor"
            />
          </PlusIcon>
        )}
      </InputWrap>
      {!!error && <ValidationMessage>{error.message}</ValidationMessage>}
    </>
  );
};

export default TimestampField;
